var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLnkd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0453 0H19.9542C8.93354 0 -0.000488281 8.93392 -0.000488281 19.9545V20.0455C-0.000488281 31.0661 8.93354 40 19.9542 40H20.0453C31.0659 40 40 31.0661 40 20.0455V19.9545C40 8.93392 31.0659 0 20.0453 0Z",
    fill: "#007EBB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.53898 13.2963C9.01205 12.8072 8.75 12.2018 8.75 11.4815C8.75 10.7611 9.01345 10.1291 9.53898 9.63863C10.0659 9.14954 10.7442 8.9043 11.5752 8.9043C12.4063 8.9043 13.0579 9.14954 13.5835 9.63863C14.1104 10.1277 14.3724 10.7429 14.3724 11.4815C14.3724 12.22 14.109 12.8072 13.5835 13.2963C13.0565 13.7854 12.388 14.0306 11.5752 14.0306C10.7624 14.0306 10.0659 13.7854 9.53898 13.2963ZM13.9296 16.1019V31.0968H9.19143V16.1019H13.9296Z",
    fill: "#FEFFFC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7023 17.583C30.7352 18.7042 31.2509 20.2429 31.2509 22.202V30.8318H26.751V22.8102C26.751 21.8223 26.4945 21.0543 25.983 20.5078C25.4715 19.9612 24.782 19.6865 23.9187 19.6865C23.0555 19.6865 22.3659 19.9598 21.8544 20.5078C21.3429 21.0543 21.0865 21.8223 21.0865 22.8102V30.8318H16.5599V16.0597H21.0865V18.0189C21.5447 17.3658 22.1628 16.8501 22.9392 16.4703C23.7155 16.0906 24.5886 15.9014 25.5598 15.9014C27.2891 15.9014 28.6709 16.4619 29.7023 17.583Z",
    fill: "#FEFFFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLnkd);
export default __webpack_public_path__ + "static/media/lnkd.a0f2b87eba276648c6786d851aa5e7e4.svg";
export { ForwardRef as ReactComponent };